import DHR from './dhr';

export default DHR;